import "../../lib/form/form.scss";
import "../Board/Notice.scss";
import "../Main.scss";
import Sub from "../Sub";

import axios from "axios";
import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import Pagination from "react-js-pagination";
import { Route, Routes, useNavigate } from "react-router-dom";
import ConfirmModal from "../../components/ConfirmModal";
import NoticeDetail from "../Board/NoticeDetail";

const Dataroom = () => {
  const [postAlways, setPostAlways] = useState([]);
  const [postNum, setPostNum] = useState([]);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [filterType, setFilterType] = useState("init");
  const [filterInput, setFilterInput] = useState("");

  // 모달
  const [showModal, setShowModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [filterValidateModal, setFilterValidateModal] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setFilterModal(true);
  };
  const closeModal = (e) => {
    e.preventDefault();
    setFilterModal(false);
    setShowModal(false);
    setFilterValidateModal(false);
  };
  const closeModal2 = () => {
    navigate("/login/userlogin");
    setShowModal(false);
  };
  useEffect(() => {
    if (window.sessionStorage.getItem("token") === null) {
      navigate("/");
      setShowModal(true);
    }
  });

  // 검색 필터 타입
  const onChangeFilterType = (e) => {
    // console.log(e.target.value);
    setFilterType(e.target.value);
  };
  const onChangeFilterInput = (e) => {
    // console.log(e.target.value);
    setFilterInput(e.target.value);
  };

  const onClickFilter = () => {
    // console.log(`onClick filterType = ${filterType}`);
    // console.log(`onClick filterInput = ${filterInput}`);
    if (filterType === "init") {
      // alert("검색필터를 선택하세요.");
      setFilterModal(true);
      setFilterInput("");
      posts();
    } else if (filterType === "titleLike" && filterInput.length === 0) {
      setFilterValidateModal(true);
    } else if (filterType === "writerLike" && filterInput.length === 0) {
      setFilterValidateModal(true);
    } else {
      setPage(0);
      PageFilterReplace();
    }
  };

  const PageFilterReplace = () => {
    // console.log(`page = ${page}`);
    posts();
  };

  let navigate = useNavigate();

  const handlePageChange = (page) => {
    posts(page);
    setPage(page);
  };

  // 날짜 => 상시
  useEffect(() => {
    axios
      .get("/api/board", {
        params: {
          pageNumber: 1,
          type: 4,
          pageSize: 3,
          state: 2,
        },
      })
      .then((response) => {
        setPostAlways(response.data.data);
      });
  }, []);

  let posts = function (pageNum) {
    if (pageNum === undefined) pageNum = 1;
    let params = { pageNumber: pageNum, type: 4, pageSize: 15 };

    if (filterType !== "init") {
      params[filterType] = filterInput;
    }
    axios
      .get("/api/board", {
        params: params,
      })
      .then((response) => {
        setPostNum(response.data.data);
        setRecords(response.data);
        setTotalItems(response.data.recordsFiltered);
      });
  };

  // 날짜 => 숫자, 상시
  useEffect(() => {
    posts();
  }, []);

  return (
    <>
      {filterModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"검색 필터"}
          content={`검색 필터를 선택해 주세요.`}
        />
      ) : null}
      {filterValidateModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"검색어 입력"}
          content={`검색어를 입력해 주세요.`}
        />
      ) : null}
      {showModal ? (
        <ConfirmModal
          closeModal={closeModal2}
          modalTitle={"로그인"}
          content={`로그인이 필요한 페이지입니다.`}
        />
      ) : null}

      <Sub to={"/dataroom"} title="자료실" />
      <div className="">
        <div className=" ">
          <form className="my_page bbs_contain" action="" method="">
            <div className="row_bbs">
              <div className="select_box">
                <select
                  defaultValue={"init"}
                  name="fruites"
                  onChange={onChangeFilterType}
                >
                  <option value="init" disabled>
                    검색필터
                  </option>
                  <option value="titleLike">제목</option>
                  <option value="writerLike">작성자</option>
                </select>
              </div>

              <div className="input_wrap">
                <input
                  className="input_box"
                  type="text"
                  placeholder="검색어를 입력하세요."
                  value={filterInput}
                  onChange={onChangeFilterInput}
                />
                <button
                  className="btn_color"
                  type="button"
                  onClick={onClickFilter}
                >
                  <FiSearch />
                </button>
              </div>
            </div>

            <Routes>
              <Route path=":id" element={<NoticeDetail />} />
            </Routes>

            <div className="row_bbs bbs_wrap">
              <table className="table_wrap">
                <thead>
                  <tr>
                    <th>번호</th>
                    <th>글제목</th>
                    <th>작성자</th>
                    <th>작성일자</th>
                  </tr>
                </thead>

                <tbody>
                  {postAlways.map((postAlwaysInfo) => {
                    // 게시글 번호 => 상시
                    return (
                      <tr className="tr_hover2" key={postAlwaysInfo.id}>
                        <td className="num_bbs">상시</td>
                        <td
                          onClick={() => {
                            window.scrollTo(0, 0);
                            navigate(`/dataroom/${postAlwaysInfo.id}`);
                          }}
                        >
                          <p>{postAlwaysInfo.title}</p>
                        </td>
                        <td>
                          <p className="auth">{postAlwaysInfo.writer}</p>
                        </td>
                        <td className="date_bbs">
                          {postAlwaysInfo.startDate
                            ?.substring(0, 11)
                            .replace(/-/g, ".")}
                        </td>
                      </tr>
                    );
                  })}

                  {postNum.map((postNumInfo) => {
                    // 게시글 번호 => 숫자, 상시
                    return (
                      <tr className="tr_hover" key={postNumInfo.id}>
                        <td className="num_bbs">{postNumInfo.orderNum}</td>
                        <td>
                          <p
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(`/dataroom/${postNumInfo.id}`);
                            }}
                          >
                            {postNumInfo.title}
                          </p>
                        </td>
                        <td>
                          <p className="auth">{postNumInfo.writer}</p>
                        </td>
                        <td className="date_bbs">
                          {(postNumInfo.startDate || postNumInfo.createAt)
                            ?.substring(0, 11)
                            .replace(/-/g, ".")}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {postAlways.length > 0 || postNum.length > 0 ? null : (
                <span style={{ textAlign: "center", marginTop: "10vh" }}>
                  등록된 목록이 없습니다
                </span>
              )}
              <div className="pagination_wrap">
                <div></div>

                <div className="pagination">
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={15}
                    totalItemsCount={totalItems}
                    pageRangeDisplayed={15}
                    onChange={handlePageChange}
                    prevPageText={"‹"}
                    nextPageText={"›"}
                  />
                </div>
                <div>
                  {/* <button
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/dataroom");
                    }}
                    className="list_btn"
                  >
                    목록
                  </button> */}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Dataroom;
